import React from "react";

const RegisterInfo = ({ registerInfo, opened_at, closed_at }) => {
  return (
    <div className="mb-4 border-bottom pb-3">
      <h4 className="mb-3">Register Information</h4>
      <div className="row">
        <div className="col-md-6">
          <p><strong>Register ID:</strong> {registerInfo.id}</p>
          <p><strong>Register Title:</strong> {registerInfo.title}</p>
          <p><strong>Cashier:</strong> {registerInfo.cashier}</p>
        </div>
        <div className="col-md-6">
          <p><strong>Opened At:</strong> {opened_at}</p>
          <p><strong>Closed At:</strong> {closed_at}</p>
        </div>
      </div>
    </div>
  );
};

export default RegisterInfo;